import { shallowMount } from "@vue/test-utils";
import LottieLoader from "@/components/core/LottieLoader";

describe("LottieLoader component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(LottieLoader);
  });

  it("Renders del component LottieLoader", () => {
    expect(wrapper).toBeDefined();
  });
});
